const NAV_EVENT = 'cmms-navigation-request'

export const emitNavigationRequest = (path) => {
  if (typeof window !== 'undefined') {
    window.dispatchEvent(new CustomEvent(NAV_EVENT, { detail: { path } }))
  }
}

export const subscribeNavigationRequest = (callback) => {
  const handler = (event) => {
    const requestedPath = event?.detail?.path
    if (typeof requestedPath === 'string' && requestedPath.length > 0) {
      callback(requestedPath)
    }
  }

  window.addEventListener(NAV_EVENT, handler)
  return () => window.removeEventListener(NAV_EVENT, handler)
}
